import React, {useRef} from 'react'

import {createLog} from '@util/logs'
import {IGlobalNavigationStyles} from '@component/header/GlobalNavigation/GlobalNavigation'

import WizIcon from '@component/images/WizIcon'
import SearchModal from '@feature/leaderboard/components/SearchModal/SearchModal'
import MobileNavigation from '@component/header/GlobalNavigation/MobileNavigation/MobileNavigation'

import NavigationSettingOperationMenu from '@component/header/GlobalNavigation/NavigationOperations/NavigationSettingOperationMenu'

import IconMenu from '@svg/gnb/ic_mo_menu.svg'
import IconSearch from '@svg/common/ic_search.svg'
import IconSearchMobile from '@svg/gnb/ic_mo_search.svg'

interface IProps {
    className?: string
    navStyles?: IGlobalNavigationStyles
}

const NavigationOperations: React.FC<IProps> = ({className, navStyles}) => {
    const mobileNavigationRef = useRef<any>()
    const searchModalRef = useRef<any>()

    const onClickSearchModal = () => {
        createLog('event', 'navigation_open_search_modal')
        searchModalRef?.current?.show()
    }

    return (
        <>
            {/* Search */}
            <WizIcon
                className={`p-[6px] hover:bg-transparent01 dark:hover:bg-dark_transparent01 md:hidden ${navStyles?.iconColor} cursor-pointer`}
                onClick={onClickSearchModal}>
                <IconSearch className={`w-[16px] md:hidden`} />
                <IconSearchMobile className={`w-[24px] hidden md:block`} />
            </WizIcon>

            {/* Language, Currency, Dark Mode ... */}
            <NavigationSettingOperationMenu className={`md:hidden ${navStyles?.iconColor} cursor-pointer`} />

            {/* Mobile Navigation Menu */}
            <WizIcon
                className={`${navStyles?.iconColor} cursor-pointer hidden md:block`}
                onClick={() => {
                    createLog('event', 'navigation_open_mobile_navigation')
                    mobileNavigationRef?.current?.show()
                }}>
                <IconMenu className={`w-[24px]`} />
            </WizIcon>

            <SearchModal ref={searchModalRef} />
            <MobileNavigation ref={mobileNavigationRef} onClickSearchModal={onClickSearchModal} />
        </>
    )
}
export default NavigationOperations
